import { render, staticRenderFns } from "./shopDes.vue?vue&type=template&id=0c57951c&scoped=true"
import script from "./shopDes.vue?vue&type=script&lang=js"
export * from "./shopDes.vue?vue&type=script&lang=js"
import style0 from "./shopDes.vue?vue&type=style&index=0&id=0c57951c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c57951c",
  null
  
)

export default component.exports